import PropTypes from 'prop-types';
import { iconPaths } from './iconPaths';

export default function Icon({ name, size = 18, ...props }) {
  return <svg className="rf-icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
    {(iconPaths[name] || iconPaths.document).map(({ tag: Shape, attrs }, index) => <Shape key={index} {...attrs} />)}
  </svg>;
}
Icon.propTypes = { name: PropTypes.string.isRequired, size: PropTypes.number };
